import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, pinEmail } from "@/hooks/useAuth";
import { PinDots, PinKeypad } from "@/features/auth/PinKeypad";
import PasskeyButton from "@/features/auth/PasskeyButton";
import { useWebAuthnSupport } from "@/hooks/usePasskey";
import { apiError } from "@/lib/http";

export default function PinLockScreen() {
  const { unlock, forgetPin, loginWithPasskey } = useAuth();
  const { platform: hasBio } = useWebAuthnSupport();
  const nav = useNavigate();
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (pin.length !== 4) return;
    setBusy(true);
    unlock(pin).catch((e) => {
      setError(apiError(e));
      setPin("");
      if (e?.response?.status === 423 || e?.response?.status === 404) setTimeout(forgetPin, 1800);
    }).finally(() => setBusy(false));
  }, [pin, unlock, forgetPin]);

  const onPasskey = (data) => { loginWithPasskey(data); nav("/"); };

  return (
    <div className="min-h-dvh bg-[var(--cream)] flex flex-col items-center justify-center px-8 text-center" data-testid="pin-lock-screen">
      <p className="eyebrow rise">nossa base</p>
      <h1 className="serif text-4xl text-[var(--coffee)] mt-2 rise rise-1">Oi de novo.</h1>
      <p className="text-sm text-[var(--coffee-muted)] mt-1 rise rise-2">{pinEmail()}</p>
      <div className="mt-10 rise rise-3"><PinDots length={pin.length} error={!!error} /></div>
      <p className="h-6 text-sm text-[var(--coral)] mt-4" data-testid="pin-error">{error}</p>
      <div className="mt-4 w-full rise rise-4"><PinKeypad value={pin} onChange={(v) => { setError(""); setPin(v); }} disabled={busy} testId="pin-unlock" /></div>
      {hasBio && (
        <div className="mt-8 w-full max-w-[260px] rise rise-4">
          <PasskeyButton email={pinEmail()} onSuccess={onPasskey} label="usar biometria" />
        </div>
      )}
      <button className="btn-ghost mt-6" onClick={forgetPin} data-testid="pin-use-password-button">entrar com a senha</button>
    </div>
  );
}
